var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"float":"right","padding":"13px"}},[_c('button',{staticClass:"button is-small is-info extra",on:{"click":_vm.create}},[_vm._m(0),_c('span',[_vm._v("Skapa API-Nyckel")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-plus"})])
}]

export { render, staticRenderFns }